"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Checkmark_1 = __importDefault(require("../Checkmark"));
var classnames_1 = __importDefault(require("../../classnames"));
var Form_1 = require("./Form");
var useDisabled_1 = __importDefault(require("./useDisabled"));
var BooleanField = function (_a) {
    var autoFocus = _a.autoFocus, children = _a.children, className = _a.className, disabled = _a.disabled, name = _a.name, onChange = _a.onChange, value = _a.value;
    var _b = Form_1.useForm(), onFormChange = _b.onFormChange, values = _b.values;
    useDisabled_1.default(name, disabled);
    var onClick = function (checked) {
        if (disabled) {
            return;
        }
        if (onChange) {
            onChange(checked);
        }
        onFormChange(name, checked);
    };
    react_1.useEffect(function () {
        var normal = value || values[name];
        if (normal === undefined || normal === null) {
            onClick(false);
        }
    }, 
    // Here we're going to explicitly ignore the rules of hooks because we only
    // want this to fire when the component mounts and not in relation to its
    // component props.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    var normal = value || values[name];
    return (react_1.default.createElement("div", { className: classnames_1.default("chq-ffd", className) },
        react_1.default.createElement(Checkmark_1.default, { autoFocus: autoFocus, checked: normal, disabled: disabled, onClick: onClick }, children)));
};
exports.default = BooleanField;
